<template>
  <v-btn
    depressed
    class="d-flex align-center cursor-pointer overflow-hidden pa-2 rounded link-chip"
    @click="handleClick"
  >
    <!-- If possible show an image avatar -->
    <v-avatar tile :size="small ? 24 : 30">
      <img :src="platformIconMap[platform]" />
    </v-avatar>

    <!-- next show the name and username next to each other -->
    <div class="ml-3">
      <div
        class="line-height-1 d-flex align-center font-weight-bold"
        :class="{ 'text-caption': small, 'text-subtitle-2': !small }"
      >
        <span v-if="small" class="first-letter-uppercase">
          {{ subtitle || platform }}
        </span>
        <span v-else> {{ previewText.substr(0, 25) }} {{ previewText.length > 25 ? "..." : "" }} </span>
      </div>
      <div
        v-if="!small"
        class="line-height-1 mt-1 first-letter-uppercase"
        :class="{ 'text-caption': small, 'text-subtitle-2': !small }"
      >
        {{ subtitle || platform }}
      </div>
    </div>

    <!-- Show an icon -->
    <v-icon class="ml-3" :small="small"> open_in_new </v-icon>
  </v-btn>
</template>

<script>
// Import helper objects
import platformRegex from "@/helpers/platformRegex"

// Export this SFC
export default {
  // Name of the component
  name: "LinkChip",

  // Accept incoming data from parent
  props: {
    // Get the URL to be shown
    url: {
      type: String,
      required: true
    },

    subtitle: {
      type: String,
      required: false,
      default: null
    },

    // Whether or not to let click work
    disableClick: {
      type: Boolean,
      required: false,
      default: false
    },

    // Whether or not to show a small version
    small: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  // Define computable properties
  computed: {
    /**
     * Detect the platform for the URL
     *
     * @returns {String}
     */
    platform() {
      // Go through name and regex
      for (const [name, regex] of Object.entries(platformRegex)) {
        // If the regex matches, return the name
        if (regex.test(this.url)) return name
      }

      // Otherwise return web
      return "web"
    },

    /**
     * Get the text to be shown for this URL
     *
     * @returns {String}
     */
    previewText() {
      return this.url.match(platformRegex[this.platform])[1] || "Invalid Link"
    }
  },

  // Define methods object
  methods: {
    /**
     * When the chip is clicked, handle the event
     *
     * @returns {void}
     */
    handleClick() {
      // If click is disabled, do nothing
      if (this.disableClick) return

      // Otherwise
      window.open(this.url, "_blank")
    }
  }
}
</script>
